import { RESET } from '../../constants.esm.js';

function isResetValue(value) {
  return value === RESET;
}

export { isResetValue };
//# sourceMappingURL=isResetValue.esm.js.map
